import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { url } from '../../reducers/url';
import { post } from '../../helpers/fetchServicesMethods';
import AlignmentExportModal from '../../shared/Modal/AlignmentExportModal';
import { useHistory } from "react-router-dom";
import _ from 'lodash';
import { get as getFromStorage } from '../../services/storage/GQStorage';

const useStyles = makeStyles(() => ({
    grow: {
        flexGrow: 1,
        width: '96%',
        padding: '24px 32px 0px 25px',
    },
    appBar: {
        backgroundColor: '#eeece1',
        color: '#000',
        marginBottom: '10px',
        boxShadow: 'none',
    },
    button: {
        color: '#000',
        backgroundColor: 'transparent',
        border: '1px solid #eeece1',
        '&:hover': {
            border: '1px solid #777',
        },
    },
    tableStyle: {
        borderBottom: '1px solid #dcd7c0',
        width: '100%',
        whiteSpace: 'pre-wrap',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '14px'
    },
    aliPre: {
        fontSize: '9pt !important',
        fontFamily: '"Courier New", monospace !important',
        // padding: '17px 0 !important',
        marginBottom: '17px !important'
    }
}));

async function getAlignmentDetails(params) {
    try {
        let alignSequences = url.alignSequences;
        return await post(alignSequences, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }

}


function AlignmentResults(props) {
    const classes = useStyles();
    const toggle = useSelector(state => state.setToggle.toggle);
    const params = props.location?.state || getFromStorage('params', {}, { parse: true });
    console.log('params', params);
    const [alignmentDetails, setAlignmentDetails] = useState([]);
    const [alignmentCount, setAlignmentCount] = useState(0);
    const [gqengineData, setGqengineData] = useState([]);
    const contentRef = useRef();
    const [showExportModal, setShowExportModal] = useState(false);
    const [result, setResult] = useState([]);
    const history = useHistory();

    const openExportModal = () => setShowExportModal(true);
    const closeExportModal = () => setShowExportModal(false);

    useEffect(() => {
        async function fetchMyAPI() {
            try {
                const result = await getAlignmentDetails(params);
                console.log('result', result);
                setResult(result);
                setAlignmentCount(result.response_content.gqengine_data.length);
                setAlignmentDetails(result.response_content);
                setGqengineData(result.response_content.gqengine_data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchMyAPI()
    }, [])

    useEffect(() => {
        console.log('alignmentDetails updated:', alignmentDetails);
    }, [alignmentDetails]);

    useEffect(() => {
        gqengineData.forEach((item, index) => {
            { console.log('item', item) }

            const chart = document.getElementById(`alignmentchart-${index}`);
            if (!chart || !chart.firstElementChild) return;

            const canvas = chart.firstElementChild;
            const context = canvas.getContext('2d');
            const d = _.cloneDeep(item);
            if (!d) return;

            if (d.RESULT_OOBD > d.RESULT_OOED) {
                [d.RESULT_OOBD, d.RESULT_OOED] = [d.RESULT_OOED, d.RESULT_OOBD];
            }

            const barheight = 15;
            const spacer = 8;
            const w = 600;

            const left_qry = d.RESULT_OOBQ - 1;
            const left_sbj = d.RESULT_OOBD - 1;
            const over_qry = d.RESULT_OOEQ - d.RESULT_OOBQ + 1;
            const over_sbj = d.RESULT_OOED - d.RESULT_OOBD + 1;
            const right_qry = d.QUERY_L - d.RESULT_OOEQ;
            const right_sbj = d.SUBJECT_L - d.RESULT_OOED;

            const left_max = Math.max(left_qry, left_sbj);
            const over_max = Math.max(over_qry, over_sbj);
            const right_max = Math.max(right_qry, right_sbj);
            const total = left_max + over_max + right_max;
            const scale = w / total;

            context.fillStyle = '#66ADEA';
            context.fillRect(scale * (left_max - left_qry), 0, scale * left_qry, barheight);
            context.fillRect(scale * (left_max + over_max), 0, scale * right_qry, barheight);

            context.fillStyle = '#CCCCCC';
            context.fillRect(scale * (left_max - left_sbj), barheight + spacer, scale * left_sbj, barheight);
            context.fillRect(scale * (left_max + over_max), barheight + spacer, scale * right_sbj, barheight);

            context.fillStyle = '#337ab7';
            context.fillRect(scale * left_max, 0, scale * over_max, barheight);

            context.fillStyle = '#999999';
            context.fillRect(scale * left_max, barheight + spacer, scale * over_max, barheight);
        });
    }, [gqengineData]);


    const handleCopyAll = () => {
        if (contentRef.current) {
            const range = document.createRange();
            range.selectNodeContents(contentRef.current);

            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    console.log('Content copied to clipboard!');
                } else {
                    console.error('Copy failed.');
                }
            } catch (err) {
                console.error('Error copying content:', err);
            }

            selection.removeAllRanges();
        }
    };

    const downloadAlignmentPair = async (type) => {
        let downloadAlignPairUrl = type === 'EXCEL' ? url.excelDownloadAlignPair : url.downloadAlignPair;

        const updatedParams = {
            ...alignmentDetails.params,
            scoring_matrix: alignmentDetails.params.matrix,
            type: type,
        };
        delete updatedParams.matrix;

        // 👇 For Excel (or any binary), pass 'blob' to your post() helper!
        try {
            // For Excel: must get binary response
            const response = await post(
                downloadAlignPairUrl,
                updatedParams,
                undefined,      // history
                undefined,      // apiKey
                type === 'EXCEL' ? 'blob' : undefined // ONLY for Excel, use 'blob'
            );

            let mimeType, fileExtension, blob;

            if (type === 'HTML') {
                mimeType = 'text/html';
                fileExtension = 'html';
                blob = new Blob([response?.response_content], { type: mimeType });
            } else if (type === 'DOC') {
                mimeType = 'application/msword';
                fileExtension = 'doc';
                blob = new Blob([response?.response_content], { type: mimeType });
            } else if (type === 'EXCEL') {
                mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileExtension = 'xlsx';
                // Axios returns response.data for blobs!
                const data = response.data ? response.data : response;
                blob = new Blob([data], { type: mimeType });
            } else {
                console.error('Unknown export type:', type);
                return;
            }

            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = `alignment_export.${fileExtension}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const getAlgoMetadata = (algo) => {
        switch (algo) {
            case 'BL2':
                return { name: 'Blast', rsLabel: 'Score', reLabel: 'Eval' };
            case 'KERR':
                return { name: 'GenePAST', rsLabel: 'Errors', reLabel: '' };
            case 'SW':
                return { name: 'Smith-Waterman', rsLabel: 'Score', reLabel: '' };
            default:
                return null;
        }
    };

    const getAlignmentSentence = (item, algo) => {
        const algoMeta = getAlgoMetadata(algo);
        if (!algoMeta) return null;

        const alnClassMap = {
            EQUAL: item.RESULT_RI === 100
                ? 'Your query is identical to this sequence.'
                : 'Your query is almost identical to this sequence.',
            INCLUDED: 'Your query is contained in this sequence.',
            CONTAINS: 'Your query contains this sequence.',
            OVERHANGS_FIVE_PRIME: "Your query overhangs over the 5' region of this sequence.",
            OVERHANGS_THREE_PRIME: "Your query overhangs over the 3' region of this sequence.",
            BOTH_PART_OF: 'A part of your query matches a part of this sequence.'
        };

        const alnClass = alnClassMap[item.RESULT_CLMATCH] || '';

        const getResidueType = (val) => {
            if (val === 'PRO') return 'aa';
            if (val === 'NUC' || val === 'NUCCS') return 'nt';
            return 'unk';
        };

        const queryType = getResidueType(item.QUERY_T);
        const subjectType = getResidueType(item.SUBJECT_T);
        const qAlnType = (queryType === 'aa' || subjectType === 'aa') ? 'aa' : 'nt';
        const sAlnType = qAlnType;

        const qFrame = '(fw)';
        const sFrame = '(fw)';

        let sentence = `${alnClass} GQ subject-centric view.\n\n`;

        sentence += `Align ${`len= ${item.RESULT_RL} ${qAlnType}, `}`;
        if (algoMeta.rsLabel) sentence += `${algoMeta.rsLabel}= ${item.RESULT_RS}`;
        if (algoMeta.reLabel && item.RESULT_RE != null) {
            sentence += `, ${algoMeta.reLabel}= ${Number(item.RESULT_RE).toExponential(2)}`;
        }
        sentence += `, Identity= ${item.RESULT_RI}%, Similarity= ${item.RESULT_RM}%`;

        sentence += `\n`;

        sentence += `Query (${item.QUERY_ID}) len= ${item.QUERY_L} ${queryType}, pos= ${item.RESULT_OBQ}-${item.RESULT_OEQ} ${qAlnType} ${qFrame}`;
        sentence += `, Identity query= ${item.RESULT_RIQ}%, Nb gaps query= ${item.RESULT_GAPQ}, Alignment coverage query= ${item.RESULT_RCQ}%`;
        if (item.RESULT_COV_BLAST != null) {
            sentence += `, HSP coverage query= ${Number(item.RESULT_COV_BLAST).toFixed(2)}%`;
        }

        sentence += `\n`;

        sentence += `Subject (${item.SUBJECT_ID}) len= ${item.SUBJECT_L} ${subjectType}, pos= ${item.RESULT_OBD}-${item.RESULT_OED} ${sAlnType} ${sFrame}`;
        sentence += `, Identity subject= ${item.RESULT_RID}%, Nb gaps subject= ${item.RESULT_GAPD}, Alignment coverage subject= ${item.RESULT_RCD}%`;

        return sentence;
    };

    const getAlignmentImageUrl = (item) => {
        const params = new URLSearchParams({
            queryframe: item.RESULT_NFQ,
            querystart: item.RESULT_OBQ,
            querystop: item.RESULT_OEQ,
            querylength: item.QUERY_L,
            subjectframe: item.RESULT_NFD,
            subjectstart: item.RESULT_OBD,
            subjectstop: item.RESULT_OED,
            subjectlength: item.SUBJECT_L,
            gqclassic: false,
        });
        return process.env.REACT_APP_BASE_URL + `lib2/img/alignview?${params.toString()}`;
    };

    function colorizeAlignmentMarkerLine(alignmentBlock) {
        const lines = alignmentBlock.trim().split('\n');
        if (lines.length !== 3) return alignmentBlock;

        const qLine = lines[0];
        const markerLine = lines[1];
        const sLine = lines[2];

        // Find the index of the first non-space character in markerLine
        const firstContentIndex = markerLine.search(/\S/);

        // Split into leading spaces and actual marker characters
        const leadingSpaces = markerLine.slice(0, firstContentIndex);
        const actualMarkers = markerLine.slice(firstContentIndex);

        let styledMarkers = '';
        for (let char of actualMarkers) {
            if (char === '+') {
                styledMarkers += '<span style="background-color: orange">+</span>';
            } else if (char === ' ') {
                styledMarkers += '<span style="background-color: yellow"> </span>';
            } else {
                styledMarkers += char;
            }
        }

        return `${qLine}\n${leadingSpaces}${styledMarkers}\n${sLine}`;
    }

    function homePage() {
        history.push('/home');
    }

    function alignSequencesDirectly() {
        history.push('/alignSequencesDirectly');
    }

    return (
        <div className={classes.grow}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div style={{ fontSize: '14px' }}>
                    <a 
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            homePage();
                        }}
                        style={{ color: '#1d7594', textDecoration: 'none', cursor: 'pointer', marginRight: 8 }}
                    >
                        Home
                    </a>
                    <span> &gt; </span>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            alignSequencesDirectly();
                        }}
                        style={{ color: '#1d7594', textDecoration: 'none', cursor: 'pointer', margin: '0 8px' }}
                    >
                        Align My Sequences
                    </a>
                    <span> &gt; </span>
                    <span style={{ fontWeight: 'bold', marginLeft: 8 }}>Result</span>
                </div>

                {/* Export Button */}
                {alignmentCount !== 0 && (
                    <Button
                        color="inherit"
                        onClick={openExportModal}
                        style={{ paddingRight: 30, whiteSpace: 'nowrap' }}
                    >
                        <span className="appLink text-initial appTextFont">Export</span>
                    </Button>
                )}
            </div>
            {result.response_status > 0 ? (
                <div>
                    <b>GenomeQuest is experiencing a problem:</b> {'Script execution failed ' + result.response_content.message}
                    <div style={{ marginTop: '20px' }}>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            history.goBack();
                        }}>Click here to return to the previous page</a>
                    </div>
                </div>
            ) : (
                <>
                    {/* {alignmentCount !== 0 && (
                        <Button
                            color="inherit"
                            style={{ float: 'right', paddingRight: '30px' }}
                            onClick={openExportModal}
                        >
                            <span className="appLink text-initial appTextFont">Export</span>
                        </Button>
                    )} */}
                    <div ref={contentRef}>
                        {alignmentCount !== 0 ? (
                            <div style={{ padding: '10px 0px' }}>
                                <span><b>Found {alignmentCount} alignment.</b></span>
                            </div>
                        ) : (
                            <span><b>No alignment can be found.</b></span>
                        )}
                        <div>
                            <legend style={{ color: '#1d7594' }}><b>ALIGNMENTS</b></legend>
                            {alignmentCount !== 0 ? (
                                <table className={classes.tableStyle}>
                                    {gqengineData.map((item, index) => {
                                        const algo = alignmentDetails.gqengine_metadata.RESULT_ALGO;
                                        const alignmentText = getAlignmentSentence(item, algo);
                                        if (!alignmentText) return null;

                                        return (
                                            <tbody key={item.RESULT_OID || index}>
                                                <tr>
                                                    <td style={{ verticalAlign: 'top', width: '25px', padding: '8px' }}>{index + 1}</td>
                                                    <td style={{ padding: '7px' }}>
                                                        {item.QUERY_ID} vs {item.SUBJECT_ID}
                                                        <br />
                                                        <div style={{ padding: '10px 0px' }}>
                                                            <img src={getAlignmentImageUrl(item)} alt="alignment graphic" />
                                                        </div>
                                                        {/* <div id={`alignmentchart-${index}`} style={{ marginLeft: '45px', padding: '10px 0px' }}>
                                                            <canvas width="600" height="45"></canvas>
                                                        </div> */}
                                                        <div>{alignmentText}</div>
                                                        <br />
                                                        <b>
                                                            <pre
                                                                className="ali-pre"
                                                                style={{ overflowX: 'auto', whiteSpace: 'pre' }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: colorizeAlignmentMarkerLine(item.RESULT_FALI_FORMATTED)
                                                                }}
                                                            ></pre>
                                                        </b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        );
                                    })}
                                </table>
                            ) : (
                                <span>No alignment can be produced.</span>
                            )}
                        </div>
                        <div style={{ marginTop: '6px' }}>
                            <legend style={{ color: '#1d7594' }}><b>AUDIT TRAIL</b></legend>
                            <table className='align-table-bordered align-font'>
                                <tbody style={{ padding: '3px 70px 3px 0px' }}>
                                    <tr className='align-table-row'>
                                        <td>Original Query: </td>
                                        <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', padding: '3px 70px 3px 0px' }}>{alignmentDetails.qdb}</td>
                                    </tr>
                                    <tr className='align-table-row'>
                                        <td>Original Subject:</td>
                                        <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', padding: '3px 70px 3px 0px' }}>{alignmentDetails.sdb}</td>
                                    </tr>
                                    <tr className='align-table-row'>
                                        <td>Strategy:</td>
                                        <td style={{ padding: '3px 70px 3px 0px' }}>{alignmentDetails.algo}</td>
                                    </tr>
                                    <tr className='align-table-row'>
                                        <td style={{ padding: '3px 70px 3px 0px' }}>Parameters:</td>
                                        {alignmentDetails.algo === 'Genepast' && <td>
                                            percent id cutoff: {alignmentDetails.strat_options.percida}%
                                            <br />scoring matrix: NUC.3.1
                                            <br />keep {alignmentDetails.best} best results per query
                                        </td>}
                                        {alignmentDetails.algo === 'Blast' && <td style={{ padding: '3px 70px 3px 0px' }}>
                                            expect cutoff: {alignmentDetails.strat_options.eval}
                                            <br />word size: {alignmentDetails.strat_options.word_size}
                                            <br />scoring matrix: {alignmentDetails.strat_options.matrix === 'default' ? 'NUC.3.1' : alignmentDetails.strat_options.matrix}
                                            <br />keep {alignmentDetails.best} best results per query
                                        </td>}
                                        {alignmentDetails.algo === 'Smith-Waterman' && <td style={{ padding: '3px 70px 3px 0px' }}>
                                            Gap openning: {alignmentDetails.strat_options.gapo}
                                            <br />Gap extension: {alignmentDetails.strat_options.gape}
                                            <br />scoring matrix: {alignmentDetails.strat_options.matrix === 'default' ? 'NUC.3.1' : alignmentDetails.strat_options.matrix}
                                            <br />keep {alignmentDetails.best} best results per query
                                        </td>}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <AlignmentExportModal
                        showModal={showExportModal}
                        closeModal={closeExportModal}
                        downloadAlignmentPair={downloadAlignmentPair}
                        handleCopyAll={handleCopyAll}
                    />
                </>
            )}
        </div>
    );
}

export default AlignmentResults;
